@if (filteredList && filteredList.length > 0) {
  <div class="flex gap-2 flex-wrap">
    @for (poi of filteredList; track $index) {
      <p-button
        [rounded]="true"
        [raised]="true"
        [text]="poi.key !== activeKey"
        (click)="poiClick(poi)"
        styleClass="p-button-xs"
        icon="fas fa-location-dot"
        [label]="poi.name"></p-button>
    }
  </div>
}
